import { torontoToday } from "../../utils/TorontoTime";
import React, { useRef, useState, useEffect } from "react";
import "./SearchArea.css";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { AiOutlineMinusCircle, AiFillPlusCircle } from "react-icons/ai";

import Selector from "../Selector";
import { TorontoAirportId, TorontoId } from "../../constant/Config";

export default function SearchArea({
  locationsFrom = [],
  locationsTo = [],
  locations = [],
  scheduleInfo,
  setscheduleInfo,
  error,
}) {
  const [open, setopen] = useState(false);
  const ref = useRef(null);
  // Derive options from the latest cities and opposite endpoint. Copying props
  // into state here leaves the dropdowns empty when cities arrive later.
  const availableLocations = (oppositeId) =>
    locations.filter((item) => {
      if (item.id === oppositeId) return false;
      const isToronto = (id) => id === TorontoId || id === TorontoAirportId;
      return !(isToronto(oppositeId) && isToronto(item.id));
    });
  const locationList = {
    from: availableLocations(scheduleInfo.to),
    to: availableLocations(scheduleInfo.from),
  };
  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setopen(false);
    }
  };
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  return (
    <div className="search-area">
      <div className="location">
        <div className="from">
          <Selector
            mainTitle={"Origin"}
            title={"Leaving from"}
            items={locationList.from}
            initialSelection={locationsFrom}
            selectedItem={(e) => {
              setscheduleInfo({
                ...scheduleInfo,
                from: e.length > 0 ? e[0].id : "",
              });
            }}
            isError={error.from}
          />
        </div>
        <div className="to">
          <Selector
            mainTitle={"Destination"}
            title={"Going to"}
            initialSelection={locationsTo}
            items={locationList.to}
            selectedItem={(e) => {
              setscheduleInfo({
                ...scheduleInfo,
                to: e.length > 0 ? e[0].id : "",
              });
            }}
            isError={error.to}
          />
        </div>
      </div>
      <div className="parameters">
        <div className={`date`}>
          <div className="title">Date</div>
          <DatePicker
            selected={scheduleInfo.date}
            onChange={(date) =>
              setscheduleInfo({ ...scheduleInfo, date: date })
            }
            minDate={torontoToday()}
            //   showTimeSelect
            //   includeTimes={timeFromWindsor}
            dateFormat="MMMM d, yyyy"
            disabledKeyboardNavigation
          />
        </div>
        <div
          className={`passengers ${error.adults ? "error" : ""}`}
          ref={ref}
          onClick={() => setopen(true)}
        >
          <div className="passengers-header">
            <div className="title">Passengers</div>
            <div className="content">{scheduleInfo.adults} passengers</div>
          </div>
          {open && (
            <div className="popup-contents">
              <div className="popup-content">
                <span>Adult</span>
                <div className="controller">
                  <AiOutlineMinusCircle
                    onClick={() =>
                      scheduleInfo.adults > 1
                        ? setscheduleInfo({
                            ...scheduleInfo,
                            adults: scheduleInfo.adults - 1,
                          })
                        : 0
                    }
                  />
                  <span>{scheduleInfo.adults}</span>
                  <AiFillPlusCircle
                    onClick={() =>
                      scheduleInfo.adults > 6
                        ? 0
                        : setscheduleInfo({
                            ...scheduleInfo,
                            adults: scheduleInfo.adults + 1,
                          })
                    }
                  />
                </div>
              </div>
              <div className="popup-content">
                <span>Luggage</span>
                <div className="controller">
                  <AiOutlineMinusCircle
                    onClick={() =>
                      scheduleInfo.luggage > 0
                        ? setscheduleInfo({
                            ...scheduleInfo,
                            luggage: scheduleInfo.luggage - 1,
                          })
                        : 0
                    }
                  />
                  <span>{scheduleInfo.luggage}</span>
                  <AiFillPlusCircle
                    onClick={() =>
                      scheduleInfo.luggage >= 4
                        ? 0
                        : setscheduleInfo({
                            ...scheduleInfo,
                            luggage: scheduleInfo.luggage + 1,
                          })
                    }
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
